import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericResponse } from '@interfaces/Generic/i-response';
import { SuccessResponse } from '@models/home/response.model';
import { IPatientsLookupDTO } from '@models/patient/patient-models';
import { ApiUrlService } from '@services/api-url/api-url.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DoctorsService {
  constructor(private apiUrlService: ApiUrlService, private http: HttpClient) {}

  getConfigurations(): Observable<any> {
    return this.http.get<any>(this.apiUrlService.getConfigurationsUrl);
  }

  postDocrorSubscriptionData(
    doctorsSubscriptionData: Object
  ): Observable<SuccessResponse> {
    return this.http.post<SuccessResponse>(
      this.apiUrlService.postDoctorSubscriptionDataUrl,
      doctorsSubscriptionData
    );
  }

  getPatientsLookup(): Observable<GenericResponse<IPatientsLookupDTO[]>> {
    return this.http.get<GenericResponse<IPatientsLookupDTO[]>>(
      `${this.apiUrlService.patientsLookupUrl}`
    );
  }

  getDoctorComplaintEmails(): Observable<any> {
    return this.http.get<any>(this.apiUrlService.doctorComplaintUrl);
  }
}
